// src/hooks/termOfPayments/useGetTermOfPayments.js
import { useQuery } from "@tanstack/react-query";
import { getAllTermOfPayments } from "../../api/apiTermOfPayments";
import i18next from "i18next";

const useGetTermOfPayments = (page = 1, perPage = 15, filters = {}) => {
    const { data, isLoading, error, refetch, isFetching } = useQuery({
        queryKey: ["termOfPayments", page, perPage, filters, i18next.language],
        queryFn: () => getAllTermOfPayments(page, perPage, filters),
        keepPreviousData: true,
    });

    const termOfPayments = data?.data || [];
    const meta = data?.data?.meta || {};

    return { termOfPayments, meta, isLoading, error, refetch, isFetching };
};

export default useGetTermOfPayments;